import { tv } from 'tailwind-variants';

export const buttonStyle = tv({
  base: 'relative flex items-center justify-center gap-x-2 px-4 rounded-lg text-sm text-secondary-two font-inter tracking-wide transition-all duration-300',
  variants: {
    fontWeight: {
      light: 'font-light',
      normal: 'font-normal',
      medium: 'font-medium',
      semibold: 'font-semibold',
      bold: 'font-bold',
    },
    textTransform: {
      uppercase: 'uppercase',
      capitalize: 'capitalize',
      lowercase: 'lowercase',
      none: ' ',
    },
    design: {
      primary:
        'bg-gradient-to-r from-primary-one to-primary-two text-white hover:saturate-[0.8]',
      'primary-fixxer': 'bg-primaryFixxer-one text-white hover:brightness-75',
      secondary: 'bg-secondary-one text-white hover:brightness-75',
      'secondary-dark': 'bg-secondary-two text-white hover:brightness-75',
      outline: 'bg-transparent border border-secondary-two hover:opacity-60',
      'icon-only': 'bg-transparent px-0 rounded-none text-[0] hover:opacity-60',
      transparent: 'bg-transparent rounded-none hover:opacity-60',
      custom: 'hover:brightness-75',
    },
    disabled: {
      true: 'opacity-50 cursor-not-allowed',
    },
    bold: {
      true: 'font-bold',
    },
    italic: {
      true: 'italic',
    },
    underline: {
      true: 'underline',
    },
    size: {
      xs: 'h-6 text-xs',
      sm: 'h-8 text-xs',
      md: 'h-10',
      lg: 'h-12',
      auto: 'h-auto',
    },
  },
  defaultVariants: {
    design: 'primary',
    fontWeight: 'normal',
    textTransform: 'uppercase',
    size: 'md',
  },
});
